import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { BankAccountModel } from '../types'

interface BankAccountState {
    loading: boolean
    marketId: string | null
    bankAccounts: BankAccountModel[]
    error: Error | string | null
  }

const initialState: BankAccountState = {
    loading: false,
    marketId: null,
    bankAccounts: [],
    error: null
}

export const bankAccountSlice = createSlice({
    name: 'bankAccount',
    initialState,
    reducers: {
        loading: state => {
            state.loading = true
            state.error = null
        },
        bankAccountsFetched: (state, action: PayloadAction<{marketId: string, bankAccounts: BankAccountModel[]}>) => {
            state.loading = false
            state.marketId = action.payload.marketId
            state.bankAccounts = action.payload.bankAccounts
        },
        bankAccountsFetchFailure: (state, action: PayloadAction<Error | string>) => {
            state.loading = false
            state.marketId = null
            state.error = action.payload
        },
        bankAccountTransactionSyncRequested: (state) => {
            state.loading = false
        },
        bankAccountTransactionSyncRequestFailure: (state, action: PayloadAction<Error | string>) => {
            state.loading = false
            state.error = action.payload
        },
    }
})

export const { 
    loading, 
    bankAccountsFetched, 
    bankAccountsFetchFailure,
    bankAccountTransactionSyncRequested,
    bankAccountTransactionSyncRequestFailure
} = bankAccountSlice.actions

export default bankAccountSlice.reducer